import { render, staticRenderFns } from "./item_dynamic_frame_below.vue?vue&type=template&id=7eaaa496"
import script from "./item_dynamic_frame_below.vue?vue&type=script&lang=js"
export * from "./item_dynamic_frame_below.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SpecTable: require('/home/ubuntu/containers/hermes_eshop/components/core/specTable.vue').default,Options: require('/home/ubuntu/containers/hermes_eshop/components/core/options.vue').default,Availability: require('/home/ubuntu/containers/hermes_eshop/components/core/availability.vue').default,HorizontalProducts: require('/home/ubuntu/containers/hermes_eshop/components/core/horizontalProducts.vue').default,Shipping: require('/home/ubuntu/containers/hermes_eshop/components/core/shipping.vue').default,Payment: require('/home/ubuntu/containers/hermes_eshop/components/core/payment.vue').default,ElementBuilder: require('/home/ubuntu/containers/hermes_eshop/components/core/elementBuilder.vue').default})
